export const TAX_SETUP_SECTION = {
  COMPANY_BASICS: "company_basics",
  OWNERSHIP: "ownership_structure",
  OPERATIONS: "where_you_operate",
  FINANCES: "finances",
} as const;

export type TaxSetupSectionId =
  (typeof TAX_SETUP_SECTION)[keyof typeof TAX_SETUP_SECTION];

export const TAX_SETUP_SECTION_TITLES: Record<TaxSetupSectionId, string> = {
  [TAX_SETUP_SECTION.COMPANY_BASICS]: "Company basics",
  [TAX_SETUP_SECTION.OWNERSHIP]: "Ownership & structure",
  [TAX_SETUP_SECTION.OPERATIONS]: "Where you operate",
  [TAX_SETUP_SECTION.FINANCES]: "Finances",
};

export const TAX_SETUP_SECTION_ORDER: TaxSetupSectionId[] = [
  TAX_SETUP_SECTION.COMPANY_BASICS,
  TAX_SETUP_SECTION.OWNERSHIP,
  TAX_SETUP_SECTION.OPERATIONS,
  TAX_SETUP_SECTION.FINANCES,
];
